module.exports = __webpack_public_path__ + "imgs/DrugPolicyAlliance.426377a04daec92e75812c9e4e235f08.png";